import React from 'react'
import { throttle } from 'libraries/lodash'
import { useDispatch, useSelector } from 'react-redux'
import { ALL_AOLS, AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { pushEvent } from 'services/AnalyticsService'
import { setSignUpModalIsOpen } from 'redux/actions'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import CompactSwitch from 'components/CompactSwitch'
import TextInput from 'components/TextInput'
import AOLDropdown from 'components/shared/AOLDropdown'
import { Star } from 'lucide-react'

const throttledPushEvent = throttle(pushEvent, 1500)

export default function TiledMenuHeader ({
  children,
  childrenPosition = 'end',
  leftChildren,
  title,
  showSelectAols = false,
  keyword,
  setKeyword,
  showFavouritesOnly,
  setShowFavouritesOnly,
  selectedAols = [],
  setSelectedAols
}) {
  const aolOptions = ALL_AOLS.map(aol => ({
    label: AOL_DISPLAY_NAMES[aol],
    selected: selectedAols.includes(aol),
    value: aol
  }))

  const isLogged = useSelector(selectIsLogged)
  const { isMobile } = useSelector(selectDeviceType)
  const dispatch = useDispatch()

  const handleFavouritesToggle = () => {
    if (!isLogged) {
      dispatch(setSignUpModalIsOpen(true))
    } else {
      const newValue = !showFavouritesOnly
      setShowFavouritesOnly(newValue)
    }
  }

  const handleSelectAols = (aol) => {
    const newSelectedAols = selectedAols.includes(aol)
      ? selectedAols.filter(selected => selected !== aol)
      : [...selectedAols, aol]
    setSelectedAols(newSelectedAols)
  }

  return (
    <div className='bg-page-background w-100'>
      <div className='layout-width-constraint pt6 pb3 flex justify-between items-start flex-column-m gap5-m'>
        <div className='flex items-center'>
          <span className='fht fw6'>{title}</span>
          {leftChildren}
        </div>
        <span className='flex flexy-m gap5 gap7-t items-end flex-wrap-m'>
          {childrenPosition === 'start' && children}
          <div>
            <CompactSwitch
              label={isMobile ? <Star className='w6' /> : <span className='nowrap'>Favourites only</span>}
              tooltip={isMobile ? 'Favourites only' : undefined}
              labelPlacement='end'
              checked={showFavouritesOnly}
              onChange={() => handleFavouritesToggle()}
              data-event-category='Favourites'
              data-event-action={`Toggle-${showFavouritesOnly ? 'Off' : 'On'}`}
              data-event-label={title}
            />
          </div>
          <div className='flexy min-w10'>
            <TextInput
              label={isMobile ? undefined : 'Keyword Finder'}
              value={keyword}
              placeholder='Enter a keyword'
              handleOnChange={val => {
                setKeyword(val)
                throttledPushEvent({
                  category: 'Keyword',
                  action: `Search [${title}]`,
                  label: val
                })
              }}
            />
          </div>
          {showSelectAols && (
            <AOLDropdown
              multi
              align='left'
              options={aolOptions}
              handleOnSelect={handleSelectAols}
            />
          )}
          {childrenPosition === 'end' && children}
        </span>
      </div>
    </div>
  )
}
